import React from 'react';
import {Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography,} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

interface CompleteTaskModalProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

export default function CompleteTaskModal({
                                              open,
                                              onClose,
                                              onConfirm,
                                          }: CompleteTaskModalProps) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
                className: 'modal-dialog'
            }}
        >
            <DialogTitle>
                Aufgabe beenden
            </DialogTitle>
            <DialogContent className="modal-content">
                <DialogContentText className="modal-content-text">
                    Sind Sie sicher, dass Sie diese Aufgabe als abgeschlossen markieren möchten?
                </DialogContentText>
                <Box className="modal-success-box">
                    <Typography className="modal-box-text modal-box-text-success">
                        Die Aufgabe wird als "Abgeschlossen" markiert und kann später bei Bedarf wieder geöffnet werden.
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions className="modal-actions">
                <Button
                    onClick={onClose}
                    className="modal-button modal-button-cancel"
                >
                    Abbrechen
                </Button>
                <Button
                    onClick={onConfirm}
                    className="modal-button modal-button-success w-full">
                    <CheckCircleIcon className="modal-icon"/>
                    Aufgabe beenden
                </Button>
            </DialogActions>
        </Dialog>
    );
}
